/**
* this will look for fields that have
* character limits, it expects a string-based selector
* for elements that have character limits
*
* author <iastley@squiz.net>
*/
export default class CharacterLimiters {
    constructor (selector) {
        this.nodes = [ ...document.querySelectorAll(selector) ];

        // settings
        this.infoText = "Characters left:";

        if (this.nodes.length) {
            this.nodes.forEach((node, i) => {
                const { charlimit } = node.dataset;
                const currentText = this._getChars(node);
                const info = document.createElement("p");
                const inputData = {
                    max: Number(charlimit),
                    remainder: Number(charlimit) - currentText,
                    index: i,
                    node,
                    info
                };

                info.classList.add("_character-limit-text");

                if (!node.getAttribute("maxlength")) node.setAttribute("maxlength", charlimit);

                info.textContent = `${ this.infoText } ${ Number(charlimit) - currentText }`;

                node.after(info);

                node.addEventListener("keyup", this._onType.bind(this, inputData));
                node.addEventListener("keydown", this._onKeyGuard.bind(this, inputData));
            });
        }
    }

    ////////////////////////////////////
    // -- events

    /**
    * prevent end-users from manually removing
    * the text limitations
    */
    _onKeyGuard = (data, e) => {
        const { remainder, max, node } = data;

        if (!remainder && !node.getAttribute("maxlength")) { 
            e.preventDefault();

            node.setAttribute("maxlength", max); 
        }
    }

    /**
    * when the end-user types into the text field
    * update the character limits
    */
    _onType = (data, e) => {
        this.current = data;

        this._update();
    }

    ////////////////////////////////////
    // -- methods

    /**
    * get the input's value
    *
    * @param {HTMLElement} node
    * the event's currently focused textarea 
    *
    * @return {int}
    */
    _getChars (node) {
        return node.value.length;
    }

    /**
    * sets the state of the current textarea
    */
    _update () {
        if (!this.current) return;

        const { info, node, max } = this.current;

        this.current.remainder = max - this._getChars(node);

        info.textContent = `${ this.infoText } ${ this.current.remainder }`;
    }
}
